module.exports = __webpack_public_path__ + "img/bb_g1_t_nose-02.79c0612f.svg";